export { default as GeneralSettingsTab } from './GeneralSettingsTab';
export { default as RegistrationFieldsTab } from './RegistrationFieldsTab';
